export class ApiError extends Error {
    public constructor(
        public readonly status: number,
        public readonly name: string,
        message: string,
        public readonly details?: unknown,
        public readonly reqId?: string,
        public readonly traceId?: string
    ) {
        super(`${name}: ${message}`);
    }
}
